if (!customElements.get("recipient-form-accordion")) {
    customElements.define(
        "recipient-form-accordion",
        class RecipientFormAccordion extends HTMLElement {
            constructor() {
                super();
                this.fields = this.querySelector('.recipient-fields');
                this.checkboxInput = this.querySelector('.recipient-form__toggle input');
                this.initAccordion();
            }

            initAccordion() {
                if (!this.checkboxInput || !this.fields) return;
                
                this.checkboxInput.addEventListener('change', () => {
                    this.toggleAccordion();
                });
                
                // Handle keyboard navigation
                this.checkboxInput.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.toggleAccordion();
                    }
                });
            }
            
            toggleAccordion() {
                const isExpanded = this.classList.contains('is-expanded');
                
                if (isExpanded) {
                    // Collapse
                    this.classList.remove('is-expanded');
                    this.fields.classList.remove('is-expanded');
                    this.fields.setAttribute('aria-hidden', 'true');
                } else {
                    // Expand
                    this.classList.add('is-expanded');
                    this.fields.classList.add('is-expanded');
                    this.fields.setAttribute('aria-hidden', 'false');
                }
            }
        }
    );
}